import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lowerString'
})
export class LowerStringPipe implements PipeTransform {
    transform(sentence: string): any {
        const words = sentence.split(' ');
        let finalText = '';
        for (let word of words) {
            word = word.replace('/', '_').replace('@', '_');
            finalText += word;
        }
        return finalText;
    }
}
